<template>
    <div class="container-fluid">
        <el-container>
            <el-header height="15%">
                <div class="row mt-4">
                    <div class="col-md-2">
                        <h4>Тематические подборки</h4>
                    </div>
                    <div class="col-md-2">
                        <el-button type="success" @click="goToPage('selection/create')">Создать новую тематическую подборку</el-button>
                    </div>
                </div>
            </el-header>
            <el-main height="80%">
                <el-form aria-label="Поиск" >
                    <el-row>
                        <!-- <el-col :span="10">
                            <el-form-item label="Поиск по названию">
                                <el-col :span="14">
                                    <el-input v-model="query.q" @change="getSelections()"></el-input>
                                </el-col>

                            </el-form-item>
                        </el-col> -->
                        <!-- <el-col :span="10">
                            <el-form-item label="Сортировка">
                                <el-select
                                v-model="query.sort"
                                :width="300"
                                @change="getSelections()">
                                    <el-option
                                      v-for="(item, index) in sortConfig"
                                      :key="index"
                                      :value="item.field"
                                      :label="item.title"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col> -->
                    </el-row>


                </el-form>
                <el-table
                    :data="selections"
                    style="width: 100%"
                    empty-text="Нет даных">
                    <el-table-column
                      prop="id"
                      label="Id"
                      width="50">
                    </el-table-column>
                    <el-table-column
                      prop="title"
                      label="Название"
                    />
                    <!-- <el-table-column
                      prop="slug"
                      label="Slug"
                    /> -->
                    <el-table-column
                      prop="products_count"
                      label="Количество товаров"
                    />
                    <el-table-column
                      prop="sort"
                      label="Сортировка"
                    >
                    </el-table-column>

                    <el-table-column
                      label="Активность"
                    >
                      <template slot-scope="scope">
                        <p v-if="!selections[scope.$index].activity">Нет</p>
                        <p v-if="selections[scope.$index].activity">Да</p>
                      </template>
                    </el-table-column>
                    <el-table-column
                      fixed="right"
                      label="Действия"
                      width="400">
                        <template slot-scope="scope">
                          <el-button v-if="selections[scope.$index].activity"
                            size="mini"
                            type="primary"
                            plain
                            @click="hideRow(scope.$index)">Скрыть</el-button>
                          <el-button v-if="!selections[scope.$index].activity"
                            size="mini"
                            type="primary"
                            plain
                            @click="restoreRow(scope.$index)">Восстановить</el-button>
                          <el-button 
                            size="mini"
                            @click="updateRow(scope.$index)">Изменить</el-button>
                          <el-button 
                            size="mini"
                            type="danger"
                            @click.native.prevent="deleteRow(scope.$index)">Удалить</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
            <el-footer height="5%">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="paginator.total"
                        :current-page.sync="paginator.current_page"
                        :hide-on-single-page="true"
                        :page-size="paginator.per_page"
                        :page-count="paginator.last_page"
                        @current-change="getPage(paginator.current_page)"
                >
                </el-pagination>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import axios from "axios";
import sortConfig from "../../composable/config/roots-sort.config"
import { SETPRELOADER_STATE } from '@/store/mutation-types'

export default {
    name: "Selections",
    data: function (){
        return {
            sortConfig,
            selections:[],
            paginator: [],
            query:{
                q:'',
                sort: sortConfig[0].field
            }
        }
    },
    computed: {
        activeSort() {
            const result = this.sortConfig.find((e) => e.field === this.query.sort)
            return result ? result.options  : undefined
        },
        queryComputed() {
            const sort = this.activeSort
            const q = this.query.q
            const result = {}
            let isChange = false;
        if (sort) {
            isChange = true
            result['sort'] = sort;
        }
        if (q) {
            isChange = true
            result['q']=q
        }
            return isChange ? result : undefined
        },
    },
    mounted() {
        this.getSelections();
    },
    methods:{
        getQuery(query) {
          const qs = require('qs');
          let q
          if (query) {
            q = query
          } else {
            q = this.queryComputed ? `?${qs.stringify(this.queryComputed)}` : ''
          }
          return q;
        },
        getSelections: async function (query){
          const q = this.getQuery(query)
          this.$store.commit(SETPRELOADER_STATE, true)
          axios.get('selection/' + q).then((response)=>{
              this.selections = response.data.data;
              this.paginator = response.data.meta;
          })
          .catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
          })
          .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
        },
        getPage: function(pageNum){
          const qs = require('qs');
          const qProps = this.queryComputed ? `&${qs.stringify(this.activeSort)}` : undefined
          const q = `?page=${pageNum}${qProps}`
          this.getSelections(q)
        },
        goToPage: function (path){
            this.$router.push(path);
        },
        deleteRow: function (index) {
          let id = this.selections[index].id;
          axios.delete('selection/'+id).then(()=>{
              this.getSelections().then(() => {
                this.$notify.success('Подборка удалена')
              });
          }).catch((errors)=>{
              if(errors.response.status === 401){
                  this.$router.push('/login');
              } else {
                this.$notify.error('Не известная ошибка')
              }
          });
        },
        hideRow: function (index) {
          let id = this.selections[index].id;

          axios.post('selection/'+id+'/hide').then(()=>{              
              this.getSelections().then(() => {
                this.$notify.success('Подборка скрыта')
              });
          }).catch((errors)=>{
              if(errors.response.status === 401){
                  this.$router.push('/login');
              } else {
                this.$notify.error('Не известная ошибка')
              }
          });
        },
        restoreRow: function (index) {
          let id = this.selections[index].id;
          axios.post('selection/'+id+'/restore').then(()=>{
            this.getSelections().then(() => {
                this.$notify.success('Подборка восстановлена')
              });
          }).catch((errors)=>{
              if(errors.response.status === 401){
                  this.$router.push('/login');
              } else {
                this.$notify.error('Не известная ошибка')
              }
          });
        },
        updateRow: function (index) {
          let id = this.selections[index].id;
          this.$router.push('/selection/'+id+'/update');
        },
    }
}
</script>

<style scoped>

</style>